import { AbsoluteModelPath, emptyModelPath } from "./ModelPath";
import { MatchKind } from "./PathMatcher";
import { ModelPathBuilder } from "./ModelPathBuilder";

export function getMatchedAndDifferentModelPaths(
    baseModelPath: AbsoluteModelPath,
    splittingModelPath: AbsoluteModelPath
) {
    const pathMatch = baseModelPath.matchFor(splittingModelPath);
    const commonPartTokens = pathMatch.map(x =>
        x.kind === MatchKind.MatchedPath
            ? x.prefix
            : x.kind === MatchKind.MatchedMultiplicity
              ? x.target
              : emptyModelPath()
    );
    const commonPart = new ModelPathBuilder(true).append(commonPartTokens).toAbsolutePath();
    const restPart =
        pathMatch.map(x => (x.kind === MatchKind.DifferentSuffix ? x.target : undefined)).find(x => x != undefined) ??
        emptyModelPath();
    return {
        matchedPath: commonPart,
        differentPath: restPart,
    };
}
